import React from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';
import { Formik, Form } from 'formik';
import { FormRow, FormCol4, FormCol12, ButtonSubmit } from 'motion-components';
import * as Yup from 'yup';

import { FieldSelectCollectionOrderState2 } from 'shared-pages/components/field-select/fs-collection-order-state2';

type Props = {
  readonly open: boolean;
  readonly close: (result: number | null | false) => void;
  readonly title?: string;
  /** Optional initial status id when opening the modal */
  readonly initialStatusId?: number | null;
} & ModalProps;

const ModalOrderStatus = ({ open, close, title, initialStatusId = null }: Props) => {
  const { t } = useTranslation();
  const displayTitle = title ?? t('Κατάσταση Αιτήματος Συλλογής');

  const validationSchema = Yup.object({
    statusId: Yup.number().nullable().required(t('Επιλέξτε κατάσταση')),
  });

  return (
    <Modal size="xl" show={open} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>{displayTitle}</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ statusId: initialStatusId }}
        validationSchema={validationSchema}
        onSubmit={(values) => close(values.statusId)}
        enableReinitialize
      >
        {({ handleSubmit, isSubmitting, isValid }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <FormRow>
                <FieldSelectCollectionOrderState2
                  name="statusId"
                  label={t('Κατάσταση Αιτήματος Συλλογής')}
                  as={FormCol12}
                  defaultValues={{}}
                  required
                  isMulti={false}
                />
              </FormRow>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                size="sm"
                className="p-2"
                style={{ minWidth: '5rem' }}
                variant="primary"
                disabled={isSubmitting || !isValid}
              >
                &nbsp;{t('OK')}&nbsp;
              </Button>
              <Button
                type="button"
                size="sm"
                className="p-2"
                style={{ minWidth: '5rem' }}
                variant="outline-secondary"
                onClick={() => close(false)}
              >
                &nbsp;{t('ΑΚΥΡΩΣΗ')}&nbsp;
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export const promiseModalOrderStatus = createModal(ModalOrderStatus);
